<span class="spinner spinner-lg loading" *ngIf="loading">
  Loading...
</span>
